import styled from 'styled-components';

import Link from '../../Link';
import Container from '../../interface/Container';

export const CircleCtaButton = styled(Link)`
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-dark);
  text-align: center;
  width: 12rem;
  height: 12rem;
  background: var(--color-secondary);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 3rem;
  right: 3rem;
  z-index: 1;
  padding: 0 3.5rem;

  &:hover {
    background: var(--color-black);
  }

  @media (${({ theme }) => theme.respondTo.mobile}) {
    display: none;
  }
`;

export const ImageOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.3) 100%);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`;

export const ImageWrapper = styled.div`
  height: 36rem;
  position: relative;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    width: 90%;
    height: 44rem;
  }

  > * {
    width: 100%;
    height: 100%;
    border-bottom-right-radius: 10rem;

    @media (${({ theme }) => theme.respondTo.tablet}) {
      border-bottom-right-radius: 22rem;
    }
  }
`;

export const Split = styled.div`
  margin-top: 4rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
    gap: 5rem;
    margin-top: 10.5rem;
  }

  @media (${({ theme }) => theme.respondTo.desktopL}) {
    grid-template-columns: repeat(auto-fill, minmax(auto, 46rem));
  }
`;

export const StyledContainer = styled(Container)`
  position: relative;
  top: -3rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    top: -4.5rem;
  }
`;

export const Subtitle = styled.h2`
  font-family: var(--font-tertiary);
  font-weight: var(--font-weight-regular);
  font-size: 3rem;
  line-height: 1.395;

  @media (${({ theme }) => theme.respondTo.mobile}) {
    color: var(--color-secondary);
  }

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 3.8rem;
  }
`;

export const Text = styled.div`
  h3 {
    font-family: var(--font-tertiary);
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-lg);
    display: block;
    margin-bottom: 3rem;
  }

  p {
    + h3 {
      margin-top: 5.5rem;
    }
  }

  @media (${({ theme }) => theme.respondTo.mobile}) {
    margin-top: 3rem;
  }
`;

export const Title = styled.h1`
  font-size: 5.2rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 9rem;
  }
`;

export const Wrapper = styled.div`
  color: var(--color-text-light);
  @media (${({ theme }) => theme.respondTo.desktop}) {
    position: relative;
    margin-bottom: 14.5rem;
  }
`;
